module.exports = __webpack_public_path__ + "media/images/fleches-6b5beea433ecc6e8a2d95320a3dc0663.svg";